import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';
import { DocumentsErrorCodes } from '../error-codes/document.type';
import { DocumentsSuccessCodes } from '../success-codes/document.type';
import { defaultDocumentsAlerts } from './en-GB/documents';
import { SupportedToasterLocales } from './general.utils';

export const documentsTranslations: {
  // For new locales just add them here to the extract
  [key in SupportedToasterLocales]: typeof defaultDocumentsAlerts;
} = {
  [Locale.en_GB]: defaultDocumentsAlerts,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateDocumentsAlerts = (translations: typeof defaultDocumentsAlerts) => ({
  [DocumentsErrorCodes.DOCUMENT_FILE_ID_NOT_FOUND]: {
    name: 'Invalid document file id',
    type: AlertTypes.ERROR,
    title: translations.DOCUMENT_FILE_ID_NOT_FOUND_TITLE,
    description: translations.DOCUMENT_FILE_ID_NOT_FOUND_DESCRIPTION,
  },
  [DocumentsErrorCodes.DOCUMENT_ID_NOT_FOUND]: {
    name: 'Invalid document id',
    type: AlertTypes.ERROR,
    title: translations.DOCUMENT_ID_NOT_FOUND_TITLE,
    description: translations.DOCUMENT_ID_NOT_FOUND_DESCRIPTION,
  },
  [DocumentsErrorCodes.DOCUMENT_TYPE_NOT_FOUND]: {
    name: 'Invalid document type',
    type: AlertTypes.ERROR,
    title: translations.DOCUMENT_TYPE_NOT_FOUND_TITLE,
    description: translations.DOCUMENT_TYPE_NOT_FOUND_DESCRIPTION,
  },
  [DocumentsErrorCodes.DOCUMENT_UPLOAD_FAILED]: {
    name: 'Failed to upload document',
    type: AlertTypes.ERROR,
    title: translations.DOCUMENT_UPLOAD_FAILED_TITLE,
    description: translations.DOCUMENT_UPLOAD_FAILED_DESCRIPTION,
  },
  [DocumentsErrorCodes.DOCUMENT_FILE_SIZE_EXCEEDED]: {
    name: 'File exceeds maximum size',
    type: AlertTypes.ERROR,
    title: translations.DOCUMENT_FILE_SIZE_EXCEEDED_TITLE,
    description: translations.DOCUMENT_FILE_SIZE_EXCEEDED_DESCRIPTION,
  },
  [DocumentsSuccessCodes.DOCUMENT_UPLOAD_SUCCESS]: {
    name: 'Document uploaded successfully',
    type: AlertTypes.SUCCESS,
    title: translations.DOCUMENT_UPLOAD_SUCCESS_TITLE,
    description: translations.DOCUMENT_UPLOAD_SUCCESS_DESCRIPTION,
  },
  [DocumentsErrorCodes.DOCUMENT_GENERATION_FAILED]: {
    name: 'Failed to generate document',
    type: AlertTypes.ERROR,
    title: translations.DOCUMENT_GENERATION_FAILED_TITLE,
    description: translations.DOCUMENT_GENERATION_FAILED_DESCRIPTION,
  },
  [DocumentsErrorCodes.HOLDING_STATEMENT_NOT_IMPLEMENTED]: {
    name: 'Holding statement not implemented',
    type: AlertTypes.ERROR,
    title: translations.HOLDING_STATEMENT_NOT_IMPLEMENTED_TITLE,
    description: translations.HOLDING_STATEMENT_NOT_IMPLEMENTED_DESCRIPTION,
  },
});
